import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const CREW_RULES_HEADINGS = new Set(['Rules for Crews', 'กฎสำหรับทีมงาน']);

const SectionMultiEnumMaybe = props => {
  const {
    heading,
    options,
    selectedOptions,
    showUnselectedOptions = true,
    isListingPage,
    forceShowHeading = false, 
  } = props;

  const hasContent = showUnselectedOptions || (selectedOptions?.length ?? 0) > 0;
  const hasRequiredProps = Boolean(heading && options);

  if (!hasRequiredProps || !hasContent) {
    return null;
  }

  const shouldShowHeading =
    !isListingPage || forceShowHeading || CREW_RULES_HEADINGS.has(heading);

  return (
    <section className={css.sectionMultiEnum}>
      {shouldShowHeading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}

      <PropertyGroup
        id="ListingPage.amenities"
        rootClassName={css.details}
        options={options}
        selectedOptions={selectedOptions}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
